module.exports = "images/contact_office_image_01.jpg";